// extracted by mini-css-extract-plugin
export default {"container":"AderenciaDePrecosHeader_container__c7HoA","title":"AderenciaDePrecosHeader_title__smRBD","subtitle":"AderenciaDePrecosHeader_subtitle__+6qPR"};